import { Component, OnInit,NgZone,ChangeDetectorRef  } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { page } from "../class/status";
import { menulist } from "../class/status";
import { environment } from "../../../environments/environment";
import { Dep } from "../class/auth";
import * as moment from 'moment';
import { variable } from "@angular/compiler/src/output/output_ast";
import * as Highcharts from 'highcharts';
import { chartdata }  from '../class/chatdata';
@Component({
    selector: "app-msgreturn",
    templateUrl: "./msgreturn.component.html",
    styleUrls: ["./msgreturn.component.css"],
})

export class MsgreturnComponent implements OnInit {
    tool_obj: any = {
        search_model: "",
        search_result_staus: false,
        check_user_info: [],
        tag:'-2'
    };
    Highcharts: typeof Highcharts = Highcharts;
    lineOptions:any = {...chartdata.line}
    lineOptions2:any = JSON.parse(JSON.stringify({...chartdata.line}));
    ck_status:any = false;
    sort_obj: any = { column: "target_date", sort: "0" };
    data: any = [];
    top_info: any = [];
    link: string = environment.link;
    edit_data: any = [];
    setting_data: {
        content: any;
        description: any;
        send_num: number;
        push_type: string;
        recharge_type: any;
        start_time: any;
        gender: string;
        gift_num: string;
        gift_type: string;
        month: string;
        route_sign: string;
        target_user_id: string;
        target_user_profile_pic: string;
        id: any;
        status: string;
        file_url: string;
        media: any;
        groupTagArr:any;
    } = {
        groupTagArr:[],
        media:'',
        id:"-999",
        file_url:'',
        content: "",
        description:"",
        status:'1',
        target_user_profile_pic:'',
        route_sign:'1',
        target_user_id:'-1',
        send_num: 500,
        push_type: "1",
        recharge_type: 1 ,
        start_time:'',
        gender:"1",
        gift_type:"1",
        gift_num:"0",
        month:"3"
    };
    mouse_obj: {
        start: number;
        end: number;
        select: number;
        target: number;
    } = { start: 0, end: 0, select: 0, target: 0 };
    preurl: string = "";
    urltoken: string = "";
    updateFlag: boolean = false;
    loading: boolean = true;
    pageobj: page = { page: 0, count: 12, total_count: 0 };
    pageobj2: page = { page: 0, count: 12, total_count: 0 };
    menu_list: menulist = [
        { id: "1", name: "未完成回歸" },
        { id: "2", name: "老友回歸" },
    ];
    pageobjstr: string = JSON.parse(JSON.stringify(this.pageobj));
    pageobjstr2: string = JSON.parse(JSON.stringify(this.pageobj2));
    now: string = "1";
    subnow: string = "1";//1是預設 2 是觀看回歸明細 3是看折線圖
    varable_list: any = [
        { id: "{{{of_user_name}}}", name: "老友名稱" ,type:0,show:1},
        { id: this.tool_obj.target_user_id, name: "扮演者名稱",type:1,show:0 },
        { id: "{{{usually_chat_user_na}}}", name: "常聊對象",type:2,show:1 },
        { id: "親愛的用戶", name: "未完成用戶",type:3,show:0},
    ];
    time :any={};
    time_info:any=-1;
    login_list: menulist = [
        { id: "-1", name: "登入不限" },
        { id: "1", name: "有登入" },
        { id: "0", name: "沒登入" },
    ];
    click_list: menulist = [
        { id: "-1", name: "點擊不限" },
        { id: "1", name: "有點擊" },
        { id: "0", name: "沒點擊" },
    ];
    deposit_list: menulist = [
        { id: "-1", name: "儲值不限" },
        { id: "1", name: "有儲值" },
        { id: "0", name: "沒儲值" },
    ];
    oriNum = 0;
    groupTagArr = [];
    tag_list_type = [];
    groupTaglist = [];
    valuetag = [];
    reward_list: menulist = [
        { id: "-1", name: "無" },
        { id: "1", name: "鑽石" },
        { id: "2", name: "活動獎勵" },
    ];
    route_sign_list: menulist = [
        { id: "1", name: "個人頁" },
        { id: "2", name: "聊天室" },
        { id: "3", name: "私密動態" },
        { id: "4", name: "探索頁" },
    ];
    ranges: any = {
        '今天': [moment(), moment()],
        '昨天': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        '過去一周': [moment().subtract(6, 'days'), moment()],
        '過去30天': [moment().subtract(30, 'days'), moment()],
    }
    // UI選項
    modes = [
        { label: '召回', value: 'recall' },
        { label: '撒嬌', value: 'cute' },
        { label: '吃醋', value: 'jealous' },
    ];
    gen = {
        mode: 'recall',     // recall | cute | jealous
        intensity: 3,       // 1~5 -> 送 feature
        emoji: true,        // -> style
        gege: true,         // -> style
        len: 'mid',         // short | mid | long -> style
        message: ''         // -> message
    };
    // 送到 Coze 的 payload（預覽用）
    cozePayload: any = {};

    constructor(public httpClient: HttpClient,private ngZone: NgZone,private cdr: ChangeDetectorRef, ) {}

    calltagList(event){
        this.groupTagArr = event;
    }

    checktag(item){
        this.subnow='1';
        this.setting_data = item;
        if(item.id<0){
            this.ck_status = true;
        }

        let arrtag = JSON.parse(item.tag_id);
        this.groupTagArr = [];

        arrtag.forEach(v => {
            this.valuetag.forEach((value,key) => {
                value.forEach(vx => {
                    if(vx.id == v){
                        this.tool_obj.groupTag = [];
                        this.tool_obj.tag = key;
                        this.tool_obj.groupTag=[vx.name];
                        this.showType(this.tool_obj.tag);

                    }
                });
            });
        });
        this.tool_obj.tag = '-2';
    }

    get_default_data(){
        this.setting_data = {groupTagArr:[],media:'',id:"-999",file_url:'', content: "",description:"",
        status:'1',
        target_user_profile_pic:'',
        target_user_id:'-1',route_sign:'1',
        send_num: 500, push_type: "1", recharge_type: 1 ,start_time:'',gender:"1",gift_type:"1",gift_num:"0",month:"3"};
        this.fresh_view_var_btn();
    }

    showType(num){
        if(this.groupTagArr.length == 0){ //一開始第一個值
            this.groupTagArr[num] = this.tool_obj.groupTag;
        }
        if(num == this.oriNum){
            if(this.tool_obj.groupTag.length <  this.groupTagArr[num].length){
                this.groupTagArr[num] =  this.groupTagArr[num].filter(item => this.tool_obj.groupTag.includes(item));
            }else{
                this.tool_obj.groupTag.forEach(item => {
                    if (!this.groupTagArr[num].includes(item)) {
                        this.groupTagArr[num].push(item);
                    }
                });
            }
        }else{ //新類型第一個值
            this.groupTagArr[num] = this.tool_obj.groupTag;
        }
        this.oriNum = num;
        // this.init_list();
    }

    clearbtn(item,idx,index){
        this.groupTagArr[idx].splice(index, 1);
        if(this.tool_obj.groupTag.includes(item)){
            const index = this.tool_obj.groupTag.indexOf(item);
            this.ngZone.run(() => {
                this.tool_obj.groupTag.splice(index, 1);
                this.tool_obj.groupTag = [...this.tool_obj.groupTag];
                this.cdr.detectChanges(); // 或者使用 this.cdr.markForCheck();
            });
        }

    }

    ngOnInit(): void {
        this.init_time();
        this.edit_data= {id:0}
        this.subnow = "3";
        this.get_track_detail();
        this.fresh_view_var_btn();
        this.syncGenParams();
    }

    /** style 統一用可解析字串：mode=xx;emoji=1;gege=1;len=mid */
    buildStyle(): string {
        const emoji = this.gen.emoji ? 1 : 0;
        const gege = this.gen.gege ? 1 : 0;
        const len = this.gen.len || 'mid';
        const mode = this.gen.mode || 'recall';
        return `mode=${mode};emoji=${emoji};gege=${gege};len=${len}`;
    }

    /** 組成 Coze workflow Start 參數（完全對你的 Coze 接收欄位） */
    syncGenParams() {
        this.cozePayload = {
            message: (this.gen.message || '').trim(),
            style: this.buildStyle(),
            feature: Number(this.gen.intensity || 3),
            usually_chat_user_na: '{{{usually_chat_user_na}}}',
            of_user_name: '{{{of_user_name}}}',
        };
    }

    resetGen() {
        this.gen = { mode: 'recall', intensity: 3, emoji: true, gege: true, len: 'mid', message: '' };
        this.syncGenParams();
    }

    /** ✅ 核心：送去 Coze → 回來塞回 setting_data.content */
    async generateByCoze() {
        this.syncGenParams();
        const body = { cozePayload: this.cozePayload };
        this.loading = true;

        this.httpClient.post<any>("/get_return_msg.php", body).subscribe({
            next: (res) => {
                this.loading = false;

                // 檢查後端回傳狀態是否成功
                if (res && res.status && res.data) {
                    // 將回傳的文案綁定到變數
                    this.setting_data.content = res.data.reply;
                } else {
                    // 處理業務邏輯上的錯誤 (例如：Coze 沒回傳內容)
                    console.error("生成失敗:", res.msg);
                    // 可視需求加入 UI 提示，例如：this.message.error(res.msg);
                }
            },
            error: (err) => {
                this.loading = false;
                // 處理 HTTP 連線錯誤
                console.error("API 連線異常:", err);
            }
        });
    }

    select(event) {
        const start = event.target.selectionStart;
        const end = event.target.selectionEnd;
        this.mouse_obj.start = start;
        this.mouse_obj.end = end;
    }

    add_var(item) {
        // let content = item;
        // if(this.now=='2' && item == '{{{of_user_name}}}'){
        //   content = '親愛的用戶～';
        // }
        const prestr = this.setting_data.content.substr(0,this.mouse_obj.start);
        const aftstr = this.setting_data.content.substr(this.mouse_obj.end);
        this.setting_data.content = `${prestr}${item}${aftstr}`;
    }

    onDateTyped(event: any) {
        const val = (event && event.target && event.target.value) ? String(event.target.value) : '';
        if (!val) { return; }
        const parts = val.split(' - ');
        if (parts.length !== 2) { return; }
        let s = moment(parts[0].trim(), 'YYYY-MM-DD', true);
        let e = moment(parts[1].trim(), 'YYYY-MM-DD', true);
        if (!s.isValid() || !e.isValid()) { return; }
        if (s.isAfter(e)) { const t = s; s = e; e = t; }
        // 冪等：與目前範圍相同就不重複觸發（避免點選後 blur 又重查一次）
        if (this.time && this.time.start === s.format('YYYY-MM-DD') && this.time.end === e.format('YYYY-MM-DD')) { return; }
        this.onRangeSelected(1, { startDate: s, endDate: e });
    }

    onRangeSelected(type,value: any) {
        if(value.startDate){
            this.time.start =  moment(value.startDate).format('YYYY-MM-DD')
            this.time.end =  moment(value.endDate).format('YYYY-MM-DD')
            this.init_list();
        }
    }

    init_time(){
        this.time.minDate = moment().subtract(60, 'days')
        this.time.maxDate = moment().subtract(-20, 'days')
        let default_status = true;
        if(this.time_info!=-1){
            const tmp = this.time_info.split("_");
            if(tmp.length==4){
                default_status = false;
                this.time.start = tmp[0]
                this.time.end = tmp[1]
                this.time.startDate = moment(tmp[0]);
                this.time.endDate = moment(tmp[1]);
            }
        }
        if(default_status){
            this.time.startDate = moment().subtract(3, 'days');
            this.time.endDate = moment().subtract(-4, 'days');
            this.time.start = moment(this.time.startDate)
            this.time.end = moment(this.time.endDate)
        }
        this.init_list();
    }

    check(type){
        let status = true;
        const must_key = [{key:'content','name':'內容'},{key:'start_time',name:'開始時間'}];
        must_key.forEach(item => {
            if (status && (typeof this.setting_data[item.key] === 'undefined' || this.setting_data[item.key].length === 0)) {
                if(type*1==1){
                    alert(`${item.name}為必填`);
                }
                status = false;
            }
        });
        this.ck_status = status;
        if(status && type == 1){
            this.save();
            document.getElementById("ModalClose")?.click();
        }
    }

    save(){
        this.loading = true;
        this.setting_data.groupTagArr = this.groupTagArr;
        const body = this.setting_data;
        this.httpClient.post<any>("/customer_service/update_user_back.php", body).subscribe((res) => {
            this.loading = false;
            if(!res.status){
                //  alert(res.msg);
                console.log(res.msg);
            }
            this.init_list();
            console.log(res);
        },(error) => {
            console.log(error);
        });
    }

    init_list() {
        console.log(this.now, this.sort_obj.column);
        this.loading = true;
        const body = {
            now_range: this.time,
            page: this.pageobj.page,
            count: this.pageobj.count,
            action: this.now,
            sort_obj: this.sort_obj,
        };
        this.httpClient.post<any>("/customer_service/user_back_list.php", body).subscribe((res) => {
            this.loading = false;
            this.data = res.data;
            this.top_info = res.top_info;
            this.pageobj.total_count = res.total_count;
            this.tag_list_type = res.groupTaglist.top;
            this.groupTaglist = res.groupTaglist.bottom;
            this.valuetag = res.groupTaglist.valuetag;
            console.log(res);
            this.pageobjstr = JSON.parse(JSON.stringify(this.pageobj));
        },(error) => {
            console.log(error);
        });
    }

    callback(pageobj: page) {
        if (JSON.stringify(this.pageobj) != JSON.stringify(pageobj)) {
            this.pageobj = pageobj;
            this.init_list();
        }
    }

    callback2(pageobj: page) {
        if (JSON.stringify(this.pageobj2) != JSON.stringify(pageobj)) {
            this.pageobj2 = pageobj;
            this.get_track_detail();
        }
    }

    get_track_detail(){
        this.loading = true;
        const body = {page: this.pageobj2.page,count:this.pageobj2.count,data:this.edit_data,subnow:this.subnow,now_range: this.time,};
        this.httpClient.post<any>("/customer_service/get_user_back_detail_log.php",body).subscribe(res => {
            this.loading = false;
            if(this.edit_data.id==0){
                this.lineOptions2.title.text = '';
                this.lineOptions2.subtitle.text = '';
                let series = [];
                for(let i in res.data.loader_info){
                    series.push(res.data.loader_info[i]);
                }
                this.lineOptions2.chart.zoomType = 'x';
                this.lineOptions2.series = series;
                this.lineOptions2.xAxis = {categories: res.data.categories };
                this.updateFlag = true;
                console.log(series,this.lineOptions2)
            }else{
                if(res.status){
                    this.edit_data.track_list = res.data;
                    this.pageobj2.total_count = res.total_count
                }else{
                    this.edit_data.track_list = [];
                    this.pageobj2.total_count = 0

                }

                if(this.subnow=="3"){
                    this.lineOptions.title.text = '';
                    this.lineOptions.subtitle.text = '';
                    let series = [];
                    for(let i in res.data.loader_info){
                        series.push(res.data.loader_info[i]);
                    }
                    this.lineOptions.chart.zoomType = 'x';
                    this.lineOptions.series = series;
                    this.lineOptions.xAxis = {categories: res.data.categories };
                    this.updateFlag = true;
                }
                this.pageobjstr2=JSON.parse(JSON.stringify(this.pageobj2))
            }
        });
    }

    choose_user(item){
        this.setting_data.target_user_id = item.id;
        this.setting_data.target_user_profile_pic = item.profile_pic
        this.fresh_view_var_btn(item.name);
    }

    fresh_view_var_btn(name=-1){
        this.varable_list.forEach(variable => {
            if (variable.type == 1) {
                if(name!=-1){
                    variable.id = name;
                }
                variable.show = name!=-1  ?1:0;
            }else if(variable.type==2){
                variable.show = name==-1 && this.now!='1' ?1:0;
            }else if(variable.type==3){//未完成回歸
                variable.show = this.now=='1' ?1:0;
            }else if(variable.type==0){
                variable.show = this.now=='2' ?1:0;
            }
        });
        this.setting_data.content = '';//切換變數砍掉內容
    }

    showdeType(num){
        if(this.groupTagArr[num] != null){
            this.tool_obj.groupTag  = this.groupTagArr[num];
        }
    }

    search(){
        if(this.tool_obj.search_model.trim().length>0){
            this.loading = true;
            const body = {
                search:this.tool_obj.search_model,
            };
            this.httpClient.post<any>("/get_user_list.php",body).subscribe(res => {
                this.tool_obj.search_result_staus = true;
                this.loading = false;
                if(res.status){
                    this.tool_obj.check_user_info = res.data
                }else{
                    this.tool_obj.check_user_info = [];
                }

                window.setTimeout(()=>{
                    this.tool_obj.search_result_staus = false;
                },3000)
            });
        }
    }

    minDate(){
        const today = new Date();
        const formattedDate = today.toISOString().slice(0, 10) + 'T00:00:00';
        return formattedDate;
        // return this.datePipe.transform(date, 'yyyy-MM-ddTHH:mm');
    }

    private formatDate(nmbr: number): string {
        var date = nmbr + "";
        date = (date.length < 2) ? "0" + date : date;
        return date;
    }


    choose(value: string) {
        this.now = value;
        this.pageobj.page = 0;
        this.init_list();
        this.fresh_view_var_btn();
    }

    async handleFileInput(files: FileList){
        console.log(files,'up',files[0].type);
        var that = this;
        that.loading = true;
        let body :FormData = new FormData();
        const send_url = environment.serverurl + "/upload.php";
        const xhr = new XMLHttpRequest();
        body.append("token",Dep.token);
        body.append("file[]",files[0]);

        if(files[0].type.indexOf('video')!=-1){
            const reader = new FileReader();
            const url = window.URL.createObjectURL(files[0]); // 取得檔案
            const video = document.getElementsByTagName('video')[document.getElementsByTagName('video').length-1];
            video.src = url + "#t=0.1";
            video.addEventListener('canplay', function () {
                const $this = this;
                window.setTimeout(async function () {
                    const image = await window.createImageBitmap($this);
                    const canvas = document.getElementsByTagName('canvas')[0];
                    const totalDurationInSeconds = video.duration;
                    console.log(totalDurationInSeconds,'totalDurationInSeconds');
                    const ratio = video.videoWidth / video.videoHeight;
                    canvas.width = 400
                    canvas.height = 400 / ratio;
                    canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
                    const img = canvas.toDataURL("image/jpeg", 0.5);
                    body.append("preview_pic", img);
                    xhr.open("POST", send_url, true);
                    xhr.onloadend = function () {
                        var res = JSON.parse(this.response);
                        that.loading = false;
                        if (res.status) {
                            const media = { file: [{ file_id: res.data[0].file_id, file_length: '', file_url: res.data[0]['file_url'], file_preview: res.data[0].preview_url }] };
                            that.setting_data.file_url =  res.data[0]['file_url'];
                            that.setting_data.media = media;
                            console.log(media);
                        }else{
                            that.setting_data.file_url =  '';
                            that.setting_data.media = '';
                        }
                    };
                    xhr.send(body);
                }, 500);
            })
        }else{
            xhr.open("POST", send_url, true);
            xhr.onloadend=function(){
                var res = JSON.parse(this.response)
                that.loading = false;
                if(res.status){
                    const media = {file:[{file_id:res.data[0].file_id,file_length:'',file_url:res.data[0]['file_url'],file_preview:res.data[0].preview_url}]};
                    that.setting_data.file_url =  res.data[0]['file_url'];
                    that.setting_data.media = media;
                    console.log(media);
                }else{
                    that.setting_data.file_url =  '';
                    that.setting_data.media = '';
                }
            }
            xhr.send(body);
        }
        const InputElement: HTMLInputElement = document.getElementById('file') as HTMLInputElement
        InputElement.value = '';
    }
}

